// Stable device identifier derived from ThumbmarkJS (open-source, no API
// key required). Used to dedup guest WS connections so 3 incognito tabs
// from the same person count as 1 in the live presence pill, and so
// signed-in users with multiple tabs still collapse to their userId.
//
// Privacy posture: same as the in-house anti-smurf fingerprint - hashes
// of device-level signals (canvas, fonts, audio, etc.) computed entirely
// client-side, never sent anywhere except a short hash on the WS upgrade.
//
// Cached in sessionStorage so the same tab doesn't recompute on every
// reload, but DOES recompute across browser restarts (which is fine; the
// hash is deterministic for the same browser+device anyway).

import { getFingerprint } from '@thumbmarkjs/thumbmarkjs';

const CACHE_KEY = 'pb_device_id';

export async function deviceId(): Promise<string> {
  if (typeof window === 'undefined') return '';
  try {
    const cached = window.sessionStorage.getItem(CACHE_KEY);
    if (cached && cached.length > 0) return cached;
    const fp = await getFingerprint();
    if (typeof fp !== 'string' || fp.length === 0) return '';
    window.sessionStorage.setItem(CACHE_KEY, fp);
    return fp;
  } catch {
    return '';
  }
}
